<script>
    export let toast = undefined;
</script>

<span>
    Hai già inserito nel form la tua mail. Manca solo il <a href="/aiuto?sectionId=payment" target="_blank" rel="noopener noreferrer" class="red-si bg-none cursor-pointer">pagamento</a>.
</span>
